import { Tournament } from "@portal-frontend-ssr/blast-api";
import { generateImageUrl } from "@portal-frontend-ssr/blast-assets-api";

export const TournamentSponsors = ({ tournament }: { tournament: Tournament }) => {
  if (!tournament.metadata?.sponsors?.items.length) {
    return null;
  }

  const { header, items } = tournament.metadata.sponsors;

  return (
    <>
      {header && <h3 className="uppercase font-style-label-l3">{header}</h3>}
      <div className="grid auto-rows-fr grid-cols-2 gap-1 sd:grid-cols-4">
        {items.map((item) => (
          <a
            key={item.logoKey}
            href={item.url}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center rounded-small border border-background-90 p-5"
          >
            <img
              src={generateImageUrl("tournament-sponsor", item.logoKey, {
                format: "auto",
                height: "40",
              })}
              alt={item.url}
              className="h-5 sd:h-10"
            />
          </a>
        ))}
      </div>
    </>
  );
};
